<template>
	<div>
		<v-flex>
			<v-card class="card-inner-wrapper-organisation">
				<div class="card-image">
					<img :src="logoUrl" alt />
				</div>
				<div class="card-title">
					{{ card_element.name }}
				</div>
			</v-card>
		</v-flex>
	</div>
</template>

<script>
import { BASE_URL } from "@/config/api/url/urls_in_app";
export default {
	props: {
		card_element: {
			type: Object,
			required: true,
		},
	},
	computed: {
		logoUrl() {
			if (this.card_element.logo) {
				// Return the actual banner URL if it exists
				return BASE_URL + this.card_element.logo;
			} else {
				// Return the placeholder image URL if the banner doesn't exist
				return require("../../../assets/img/placeholder.png");
			}
		},
	},
	methods: {
		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		},
	},
};
</script>

<style lang="scss" scoped>
.flex {
	height: 100%;
	.card-inner-wrapper-organisation {
		background-color: white;
		box-shadow: none;
		border: 3px solid rgba(117, 117, 117, 0.1);
		border-radius: 5px;
		display: flex;
		justify-content: flex-start;

		flex-direction: column;
		height: 100%;
		.card-image {
			width: 100%;
			img {
				width: 100%;
				max-height: 220px;
				height: 100%;
				object-fit: cover;
			}
		}
		.card-title {
			font-size: 16px;
			font-weight: 800;
			letter-spacing: 0.3px;
			color: #2b2b2b;
			line-height: 1.2;
			padding: 5px 10px;
			// text-overflow: ellipsis;
			// word-break: break-all;
			// overflow: hidden;
			// white-space: nowrap;
			// max-width: 300px;
		}
	}
}
</style>
